import { IComponentOptions, IController } from 'angular';
import './gmc-progress-bar.component.scss';

export class GmcProgressBarController implements IController {
  percent: number;
  color = '#174358';
  completeColor = 'green';
  errorColor = 'red';
  height = '5px';
  error: boolean;

  getStyles(): any {
    return {
      width: this.percent + '%',
      backgroundColor: this.error ? this.errorColor : this.percent >= 100 ? this.completeColor : this.color,
      height: this.height
    };
  }
}

export const GmcProgressBarComponent: IComponentOptions = {
  controller: GmcProgressBarController,
  template: require('./gmc-progress-bar.component.html'),
  bindings: {
    percent: '<',
    color: '@?',
    height: '@?',
    error: '<'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-progress-bar/gmc-progress-bar.component.ts